import { TIME_ZONE } from './format';

export const E_TRANSFER_EMAIL = 'leaguepay@ftlovolleyball.ca';

export const screenshotRequest = (email: string) =>
  `📸 Confirmation: Please email ${email} a screenshot of your completed e-transfer.`;

/** How long an approved team has to pay, counted from the approval email. */
export const PAYMENT_WINDOW_HOURS = 48;

const HOUR_MS = 3_600_000;
const DAY_MS = 24 * HOUR_MS;
/** 3 p.m. in `TIME_ZONE`, a fixed UTC-7, is 22:00 UTC. */
const DEADLINE_UTC_MS = 22 * HOUR_MS;

const deadlineFormatter = new Intl.DateTimeFormat('en-CA', {
  weekday: 'short',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  timeZone: TIME_ZONE,
});

/** The first 3 p.m. at least `PAYMENT_WINDOW_HOURS` after `now`, such as `Fri., Nov. 13, 3 p.m.`. */
export function paymentDeadline(now: Date): string {
  const due = now.getTime() + PAYMENT_WINDOW_HOURS * HOUR_MS;
  return deadlineFormatter.format(
    Math.ceil((due - DEADLINE_UTC_MS) / DAY_MS) * DAY_MS + DEADLINE_UTC_MS,
  );
}

/** A memo reads `<code> - <details…> - <payment code>`; `readMemo` takes back the first and last parts, so the details are free text. */
export function eTransferMemo(
  code: string,
  details: string[],
  paymentCode: string,
): string {
  return [code, ...details, paymentCode]
    .filter((part) => part !== '')
    .join(' - ');
}

export function readMemo(
  memo: string,
): { code: string; paymentCode: string } | null {
  const parts = memo
    .toUpperCase()
    .split('-')
    .map((part) => part.trim())
    .filter(Boolean);
  return parts.length < 2
    ? null
    : { code: parts[0]!, paymentCode: parts.at(-1)! };
}
